import { render, staticRenderFns } from "./footer-navi.vue?vue&type=template&id=1e3c67a4&scoped=true"
import script from "./footer-navi.vue?vue&type=script&lang=ts"
export * from "./footer-navi.vue?vue&type=script&lang=ts"
import style0 from "./footer-navi.vue?vue&type=style&index=0&id=1e3c67a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c67a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VSpacer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e3c67a4')) {
      api.createRecord('1e3c67a4', component.options)
    } else {
      api.reload('1e3c67a4', component.options)
    }
    module.hot.accept("./footer-navi.vue?vue&type=template&id=1e3c67a4&scoped=true", function () {
      api.rerender('1e3c67a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/footer-navi.vue"
export default component.exports